import React from "react";
import "../../css/styles.css";

export default function Backgroundcolor(props) {
  return (
    <div className="back-color2">
      <div className="title-text">{props.text}</div>
    </div>
  );
}
